import { lang } from '@lang';
import { Trash2 } from 'lucide-react';
import { useDesign } from '@hooks';

import { Feature } from '..';
import { selectSkuPromotionalSku, setSkuPromotionalSku, useAppDispatch, useAppSelector } from '@state';
import { stringify } from 'querystring';


export const useChangeSkuPromotionalSkuFeature = (): Feature<string> => {
	const [controller] = useDesign();
	const dispatch = useAppDispatch();

	const kitchen = controller?.kitchen ?? null;
	const skuPromotionalSku = useAppSelector(selectSkuPromotionalSku);
	return {
		name: 'remove-promotional-sku',
		label: lang.promotionalSku.label.delete,
		shortcut: '',
		tooltip: lang.promotionalSku.tooltip.deleteSku,
		icon: (props = {}) => <Trash2 {...props} />,
		disabled: false,
		value: '',
		hidden: false,
		handler: () => {
			const [sku, value] = skuPromotionalSku;
			const promotionalSku = kitchen?.promotionalSkus.findBySku(sku);
			if (promotionalSku) {
				promotionalSku.sku = value;
			}

			dispatch(setSkuPromotionalSku([]));
		}
	};
};
